import * as React from "react";

import { ExtendedFTNode } from "typings/flexFramework/FlexComponent";
import { LobFormWithTabs } from "components/shared/StorefrontWizard/LobFormWithTabs/LobFormWithTabs";
import { LobQueryRouter } from "components/shared/StorefrontWizard/LobQueryRouter";

interface TabbedWizardProps {
  wizardLOBs: ExtendedFTNode[];
  context: any;
  wizardFormChildren: React.ReactElement[];
  trackOnChangeTab?: (tab: string) => void;
  aboveOtherFormChildren?: React.ReactElement[];
  belowOtherFormChildren?: React.ReactElement[];
}

export const WizardTabbed = ({
  wizardLOBs,
  context,
  wizardFormChildren,
  trackOnChangeTab,
  aboveOtherFormChildren,
  belowOtherFormChildren,
}: TabbedWizardProps) => {
  const forms = (
    <LobFormWithTabs
      context={context}
      lobForms={wizardFormChildren}
      wizardFormSpacing={{ padding: { inline: "six" } }}
      trackOnChangeTab={trackOnChangeTab}
    />
  );

  return (
    <>
      <LobQueryRouter lobs={wizardLOBs} />

      {aboveOtherFormChildren}

      {forms}

      {belowOtherFormChildren}
    </>
  );
};
